module.exports = __webpack_public_path__ + "static/media/paso3-cambio.1f5d6ab1.png";